import { z } from "zod";

export const deviceSubmissionResponseBodySchema = z.strictObject({
  version: z.literal(1).describe("The schema version of the response"),
  measurementInterval: z
    .uint32()
    .describe("How often to perform a measurement, in seconds"),
  sendInterval: z
    .uint32()
    .describe("How often to send the measurements to the server, in seconds"),
  maxLocationFixTime: z
    .uint32()
    .describe(
      "The maximum time to wait for a location fix, in seconds. 0 means disable GNSS",
    ),
  eventLevel: z
    .enum(["error", "info", "debug"])
    .describe("The minimum level of events to report"),
  firmwareUpdateAvailable: z
    .boolean()
    .describe("True if a firmware update is available"),
});
